import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "header-user" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 2,
  class: "user-trigger__badge"
}
const _hoisted_5 = { class: "user-dd" }
const _hoisted_6 = { class: "user-dd__content" }
const _hoisted_7 = { class: "user-dd__name" }
const _hoisted_8 = { class: "user-dd__email" }
const _hoisted_9 = { class: "user-dd__content" }
const _hoisted_10 = {
  key: 0,
  class: "user-dd__status-text"
}
const _hoisted_11 = {
  key: 1,
  class: "user-dd__status-placeholder"
}
const _hoisted_12 = {
  key: 0,
  class: "user-dd__status-editor"
}
const _hoisted_13 = { class: "user-dd__status-actions" }
const _hoisted_14 = { class: "user-dd__content" }
const _hoisted_15 = { class: "user-dd__text" }
const _hoisted_16 = { class: "user-dd__content" }
const _hoisted_17 = { class: "user-dd__text" }
const _hoisted_18 = {
  key: 2,
  class: "user-dd__item user-dd__item--clickable user-dd__item-invalid"
}
const _hoisted_19 = { class: "user-dd__content" }
const _hoisted_20 = { class: "user-dd__text" }
const _hoisted_21 = { class: "user-dd__content" }
const _hoisted_22 = { class: "user-dd__text" }

import { i18n } from "@/i18n";
import {
	computed,
	ref,
	watch
} from "vue"
import { useRouter } from "vue-router"
import AppResizableDropdown from "@/components/ui-kit/dropdown/AppResizableDropdown.vue"
import AppCustomTextarea from "@/components/ui-kit/textarea/AppCustomTextarea.vue"
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue"
import AppButton from "@/components/ui-kit/button/AppButton.vue"
import { workerStore } from "@/store/worker"
import { headerStore } from "@/store/header"
import { logout } from "@/composables/useSession"
import { resolvePhotoUrl } from "@/utils/urlHelpers"
import { postToAngular, SETTINGS_SECTION_PROFILE } from "@/utils/angularEmbed"
import { useBreakpoints } from "@/composables/useBreakpoints"
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderUserDropdown',
  emits: ["openNotifications", "openMessages"],
  setup(__props, { emit: __emit }) {

const router = useRouter()

const wStore = workerStore()
const hStore = headerStore()
const { isMobile, isTablet } = useBreakpoints()
const isCompactMode = computed(() => isMobile.value || isTablet.value)

const dropdownRef = ref<InstanceType<typeof AppResizableDropdown> | null>(null)
const emit = __emit

const profile = computed(() => wStore.workerProfile)
const notificationsCount = computed(() => hStore.notificationCount.JobCount || 0)
const messagesCount = computed(() => hStore.unreadMessagesCount || 0)
const hasChatsAccess = computed(() => hStore.chatsAccess !== false)
const unreadCount = computed(() =>
	notificationsCount.value + (hasChatsAccess.value ? messagesCount.value : 0)
)
const hasUnreadItems = computed(() => isMobile.value && unreadCount.value > 0)
const notificationsLabel = computed(() => notificationsCount.value
	? `Новых уведомлений: ${notificationsCount.value}`
	: 'Новых уведомлений нет'
)
const messagesLabel = computed(() => messagesCount.value
	? `Новых сообщений: ${messagesCount.value}`
	: 'Новых сообщений нет'
)

const onOpenSettings = () => {
	dropdownRef.value?.close()
	if (router.currentRoute.value.path === '/settings') {
		postToAngular({ type: 'settings_section', section: SETTINGS_SECTION_PROFILE })
		return
	}
	router.push('/settings')
}

const onOpenNotifications = () => {
	dropdownRef.value?.close()
	emit('openNotifications')
}

const onOpenMessages = () => {
	dropdownRef.value?.close()
	emit('openMessages')
}

const avatarLiter = computed(() => {
	const liter = profile.value?.PhotoLiter?.trim()
	if (liter) return liter
	const name = profile.value?.Name?.trim()
	return name ? name.charAt(0).toUpperCase() : '?'
})

const editingStatus = ref(false)
const draftStatus = ref<string>('')

watch(profile, (val) => {
	if (!editingStatus.value) {
		draftStatus.value = val?.Status ?? ''
	}
}, { immediate: true })

const onEditStatus = () => {
	draftStatus.value = profile.value?.Status ?? ''
	editingStatus.value = true
}

const onCancelStatus = () => {
	editingStatus.value = false
	draftStatus.value = profile.value?.Status ?? ''
}

const onSaveStatus = async () => {
	try {
		await wStore.setStatus(draftStatus.value)
		editingStatus.value = false
	} catch (e) {
		console.error('[HeaderUserDropdown] save status failed', e)
	}
}

const soundLabel = computed(() => String(i18n.global.t(hStore.enableSound ? 'sound_on' : 'sound_off')))

const soundIconName = computed(() => hStore.enableSound ? 'sound-on' : 'sound-off')

const onToggleSound = () => {
	hStore.toggleSound()
}

const onLogout = () => {
	logout({ rememberRoute: false })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppResizableDropdown, {
      ref_key: "dropdownRef",
      ref: dropdownRef,
      position: "bottom",
      trigger: "click",
      "bottom-sheet-on-mobile": false,
      "content-class": "header-user-dropdown"
    }, {
      activator: _withCtx(() => [
        _createVNode(AppTooltip, {
          text: profile.value?.Name ?? '',
          disabled: !profile.value?.Name
        }, {
          activator: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              class: "user-trigger",
              "aria-label": profile.value?.Name ?? ''
            }, [
              (profile.value?.PhotoLink)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: _normalizeClass([
								'user-trigger__avatar',
								'user-trigger__avatar--img',
								{ 'user-trigger__avatar--has-unread': hasUnreadItems.value }
							]),
                    src: _unref(resolvePhotoUrl)(profile.value.PhotoLink),
                    alt: ""
                  }, null, 10, _hoisted_3))
                : (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: _normalizeClass([
								'user-trigger__avatar',
								'user-trigger__avatar--liter',
								{ 'user-trigger__avatar--has-unread': hasUnreadItems.value }
							])
                  }, _toDisplayString(avatarLiter.value), 3)),
              (_unref(isMobile) && unreadCount.value > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(unreadCount.value), 1))
                : _createCommentVNode("", true)
            ], 8, _hoisted_2)
          ]),
          _: 1
        }, 8, ["text", "disabled"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass(["user-dd__item", _unref(isMobile) ? 'user-dd__item--mobile-profile' : 'user-dd__item--clickable']),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (!_unref(isMobile) && onOpenSettings()))
          }, [
            _createVNode(AppIcon, {
              name: "user",
              width: "18px",
              color: "#FFFFFF",
              class: "user-dd__icon"
            }),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(profile.value?.Name || '—'), 1),
              _createElementVNode("div", _hoisted_8, _toDisplayString(profile.value?.Mail || ''), 1)
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass([
					'user-dd__item',
					editingStatus.value ? 'user-dd__item--editing' : 'user-dd__item--clickable'
				]),
            onClick: _cache[5] || (_cache[5] = ($event: any) => (!editingStatus.value && onEditStatus())),
            style: {"align-items":"center","min-height":"34px"}
          }, [
            _createVNode(AppIcon, {
              name: "comment",
              width: "18px",
              color: "#FFFFFF",
              class: "user-dd__icon"
            }),
            _createElementVNode("div", _hoisted_9, [
              (!editingStatus.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (profile.value?.Status)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(profile.value?.Status), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.$t('status_placeholder')), 1))
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (isCompactMode.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createVNode(AppCustomTextarea, {
                            modelValue: draftStatus.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((draftStatus).value = $event)),
                            class: "user-dd__status-textarea",
                            placeholder: _ctx.$t('status_label'),
                            "min-height": 34,
                            "max-height": 260,
                            "auto-focus": "",
                            onCtrlEnter: onSaveStatus,
                            onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                          }, null, 8, ["modelValue", "placeholder"]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "user-dd__status-save",
                            onClick: _withModifiers(onSaveStatus, ["stop"])
                          }, [
                            _createVNode(AppIcon, {
                              name: "check-round",
                              width: "18px",
                              color: "#D2D2D2",
                              "hover-color": "#FFFFFF",
                              cursor: "pointer"
                            })
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createVNode(AppCustomTextarea, {
                            modelValue: draftStatus.value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((draftStatus).value = $event)),
                            placeholder: _ctx.$t('status_label'),
                            "min-height": 80,
                            "max-height": 400,
                            "auto-focus": "",
                            "clear-hint-text": _ctx.$t('status_clear'),
                            onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                          }, null, 8, ["modelValue", "placeholder", "clear-hint-text"]),
                          _createElementVNode("div", _hoisted_13, [
                            _createVNode(AppButton, {
                              type: "secondary",
                              label: _ctx.$t('cancel_short'),
                              onClick: onCancelStatus
                            }, null, 8, ["label"]),
                            _createVNode(AppButton, {
                              label: _ctx.$t('save'),
                              onClick: onSaveStatus
                            }, null, 8, ["label"])
                          ])
                        ], 64))
                  ], 64))
            ])
          ], 2),
          (isCompactMode.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "user-dd__item user-dd__item--clickable",
                onClick: onOpenNotifications
              }, [
                _createVNode(AppIcon, {
                  name: "burger",
                  width: "18px",
                  color: "#FFFFFF",
                  class: "user-dd__icon"
                }),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, _toDisplayString(notificationsLabel.value), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (isCompactMode.value && hasChatsAccess.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "user-dd__item user-dd__item--clickable",
                onClick: onOpenMessages
              }, [
                _createVNode(AppIcon, {
                  name: "envelope",
                  width: "18px",
                  color: "#FFFFFF",
                  class: "user-dd__icon"
                }),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("span", _hoisted_17, _toDisplayString(messagesLabel.value), 1)
                ])
              ]))
            : (isCompactMode.value && !hasChatsAccess.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createVNode(AppIcon, {
                    name: "envelope",
                    width: "18px",
                    color: "#979797",
                    class: "user-dd__icon"
                  }),
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "user-dd__content" }, [
                    _createElementVNode("span", {
                      class: "user-dd__text",
                      style: {"color":"#979797"}
                    }, "Нет доступа к чатам")
                  ], -1))
                ]))
              : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "user-dd__item user-dd__item--clickable",
            onClick: onToggleSound
          }, [
            _createVNode(AppIcon, {
              name: soundIconName.value,
              width: "18px",
              color: "#FFFFFF",
              class: "user-dd__icon"
            }, null, 8, ["name"]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("span", _hoisted_20, _toDisplayString(soundLabel.value), 1)
            ])
          ]),
          _createElementVNode("div", {
            class: "user-dd__item user-dd__item--clickable",
            onClick: onLogout
          }, [
            _createVNode(AppIcon, {
              name: "logout",
              width: "18px",
              color: "#FFFFFF",
              class: "user-dd__icon"
            }),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('logout')), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 512)
  ]))
}
}

})